import React, {useState, useEffect} from "react";
import "moment/locale/el";
import moment from "moment-timezone";
import locale from "antd/es/date-picker/locale/el_GR";
import http from "../../../Utilities/http";
import Loading from "../../Common/Loading";
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Select,
  message,
  Checkbox,
} from "antd";
import {PlusOutlined, MinusOutlined} from "@ant-design/icons";
import ApiService from "../../../services/ApiService";

const {Option} = Select;
const layout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 17,
  },
};
const validateMessages = {
  required: "Υποχρεωτικό πεδίο: ${label} ",
  types: {
    number: "Μη έγκυρος αριθμός",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

function ShippingOrderForm(props) {
  const {
    onSuccessfullSave,
    taxOffices,
    measurementUnits,
    formConfig,
    paymentMethods,
    deliveryTerms
  } = props;

  const [isLoading, setLoading] = useState(false);
  const [isDifferentInvoiceReceiver, setIsDifferentInvoiceReceiver] =
    useState(false);
  const [invoiceReceiverDataChanged, setInvoiceReceiverDataChanged] =
    useState(false);
  const [invoiceTaxRegNumberHasValue, setInvoiceTaxRegNumberHasValue] =
    useState(false);
  const [isReceiverDropDown, setIsReceiverDropDown] =
    useState(false);
  const [availableRecipients, setAvailableRecipients] = useState([]);
  const [form] = Form.useForm();
  const [prefilledFields, setPrefilledFields] = useState(new Set());

  const [isPaymentRequired, setIsPaymentRequired] = useState(false);
  const [hiddenFields, setHiddenFields] = useState(new Set());
  const [lockedFields, setLockedFields] = useState(new Set());
  const [allowedMeasurementUnits, setAllowedMeasurementUnits] = useState([]);

  moment.tz.setDefault("Europe/Athens");

  useEffect(() => {
    ApiService.getRecipients().then(res => {
      setAvailableRecipients(res.data);
    })
    ApiService.getShippingOrderFormEffective().then((res) => {
      const fieldsConfig = res.data.fieldsConfig;
      const allowedMeasurementUnits = res.data.allowedMeasurementUnits;

      const prefilled = {};
      const hidden = [];
      const locked = [];
      if (fieldsConfig) {
        for (const fieldName in fieldsConfig) {
          const config = fieldsConfig[fieldName];
          if (config.defaultValue != null) {
            if (fieldName === 'isDifferentInvoiceReceiver') {
              prefilled[fieldName] = String(config.defaultValue).toLowerCase() === 'true';
            } else {
              prefilled[fieldName] = config.defaultValue;
            }
          }
          if (config.hidden) {
            hidden.push(fieldName);
          }
          if (config.locked) {
            locked.push(fieldName);
          }
        }
      }
      const data = {...prefilled};
      if (data.isReceiverDropDown) {
        setIsReceiverDropDown(data.isReceiverDropDown);
      }
      if (data.docDate) {
        if (data.docDate === 'TODAY') {
          data.docDate = moment();
        } else if (data.docDate === 'TOMORROW') {
          data.docDate = moment().add(1, 'days');
        } else {
          data.docDate = moment(data.docDate);
        }
      }
      if (data.dispatchDate) {
        if (data.dispatchDate === 'TODAY') {
          data.dispatchDate = moment();
        } else if (data.dispatchDate === 'TOMORROW') {
          data.dispatchDate = moment().add(1, 'days');
        } else {
          data.dispatchDate = moment(data.dispatchDate);
        }
      }
      if (data.deliveryDate) {
        if (data.deliveryDate === 'TODAY') {
          data.deliveryDate = moment();
        } else if (data.deliveryDate === 'TOMORROW') {
          data.deliveryDate = moment().add(1, 'days');
        } else {
          data.deliveryDate = moment(data.deliveryDate);
        }
      }
      form.setFieldsValue(data);

      if (data.isDifferentInvoiceReceiver != null) {
        setIsDifferentInvoiceReceiver(data.isDifferentInvoiceReceiver);
      }
      if (data.paymentType != null) {
        setIsPaymentRequired(data.paymentType == 0);
      }
      if (data.receiverInvoiceTaxRegistrationNumber != null) {
        setInvoiceTaxRegNumberHasValue(!!data.receiverInvoiceTaxRegistrationNumber);
      }

      setPrefilledFields(new Set(Object.keys(prefilled)));
      setHiddenFields(new Set(hidden));
      setLockedFields(new Set(locked));
      if (allowedMeasurementUnits) {
        setAllowedMeasurementUnits(allowedMeasurementUnits);
      }
    }).catch((error) => {
      this.setState({formConfig: {}});
    });

  }, [form]);

  const onFinish = (values) => {
    setLoading(true);
    http
      .post("/ShippingOrder", values)
      .then((result) => {
        setLoading(false);
        message.success("Επιτυχής αποθήκευση");
        onSuccessfullSave();
      })
      .catch((error) => {
        message.error("Σφάλμα αποθήκευσης");
        setLoading(false);
      });
  };

  const unitTypeOptions = (
    deliveryTerms.map((_) => (
      <Option value={_.code} key={_.code}>
        {_.description}
      </Option>
    )));

  const measurementUnitOptions = (
    measurementUnits
      ? allowedMeasurementUnits && allowedMeasurementUnits.length > 0
        ? measurementUnits.filter((unit) =>
          allowedMeasurementUnits.includes(unit.code)
        )
        : measurementUnits
      : []
  ).map((_) => (
    <Option value={_.code} key={_.code}>
      {_.description}
    </Option>
  ));

  return (
    <Loading loading={isLoading}>
      <Form
        {...layout}
        onFinish={onFinish}
        validateMessages={validateMessages}
        name="shipping-orders-form"
        form={form}
      >
        <Form.Item
          name="invoiceNumber"
          label="Αριθμός παραστατικού"
          rules={[{required: !lockedFields.has('invoiceNumber')}]}
          hidden={hiddenFields.has('invoiceNumber')}
        >
          <Input disabled={lockedFields.has('invoiceNumber')}/>
        </Form.Item>
        <Form.Item
          name="docDate"
          label="Ημερομηνία καταχώρησης"
          rules={[{required: !lockedFields.has('docDate')}]}
          hidden={hiddenFields.has('docDate')}
        >
          <DatePicker
            locale={locale}
            format="D/M/YYYY"
            style={{width: "100%"}}
            disabled={lockedFields.has('docDate')}
          />
        </Form.Item>
        <Form.Item
          name="dispatchDate"
          label="Ημερομηνία Αποστολής"
          rules={[{required: !lockedFields.has('dispatchDate')}]}
          hidden={hiddenFields.has('dispatchDate')}
        >
          <DatePicker
            locale={locale}
            format="D/M/YYYY"
            style={{width: "100%"}}
            disabled={lockedFields.has('dispatchDate')}
          />
        </Form.Item>
        {isReceiverDropDown && (
          <Form.Item
            name="receiverName"
            label="Παραλήπτης"
            rules={[{ required: true, message: 'Παρακαλώ επιλέξτε παραλήπτη' }]}
          >
            <Select
              showSearch
              placeholder="Αναζήτηση παραλήπτη"
              optionFilterProp="children"
              onChange={(value) => {
                console.log(value);
                const recipient = availableRecipients.find(r => r.code === value);
                if (recipient) {
                  const fieldsToUpdate = {
                    receiverName: recipient.name,
                    receiverAddress: recipient.address1,
                    receiverTown: recipient.fCityCode,
                    receiverCounty: 'Greece',
                    receiverZipcode: recipient.fPostalCode,
                    receiverTel: recipient.telephone1
                  };
                  if (!invoiceReceiverDataChanged) {
                    fieldsToUpdate.receiverInvoiceName =fieldsToUpdate.receiverName
                    fieldsToUpdate.receiverInvoiceAddress =fieldsToUpdate.receiverAddress
                    fieldsToUpdate.receiverInvoiceTown =fieldsToUpdate.receiverTown
                    fieldsToUpdate.receiverInvoiceCounty =fieldsToUpdate.receiverCounty
                    fieldsToUpdate.receiverInvoiceZipcode =fieldsToUpdate.receiverZipcode
                    fieldsToUpdate.receiverInvoiceTel =fieldsToUpdate.receiverTel
                    fieldsToUpdate.receiverInvoiceMobile =fieldsToUpdate.receiverMobile
                  }
                  console.log('updating');
                  form.setFieldsValue(fieldsToUpdate);
                }
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {availableRecipients.map(recipient => (
                <Option key={recipient.code} value={recipient.code}>{recipient.name}</Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {!isReceiverDropDown && (
        <Form.Item
          name="receiverName"
          label="Παραλήπτης"
          rules={[{required: !lockedFields.has('receiverName')}]}
          hidden={hiddenFields.has('receiverName') || isReceiverDropDown}
        >
          <Input
            disabled={lockedFields.has('receiverName')}
            onChange={(e) => {
              if (!invoiceReceiverDataChanged) {
                form.setFieldsValue({
                  receiverInvoiceName: e.target.value,
                });
              }
            }}
          />

        </Form.Item>
        )}
        <Form.Item
          name="receiverAddress"
          label="Οδός"
          rules={[{required: !lockedFields.has('receiverAddress')}]}
          hidden={hiddenFields.has('receiverAddress')}
        >
          <Input
            disabled={lockedFields.has('receiverAddress')}
            onChange={(e) => {
              if (!invoiceReceiverDataChanged) {
                form.setFieldsValue({
                  receiverInvoiceAddress: e.target.value,
                });
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="receiverTown"
          label="Πόλη"
          rules={[{required: !lockedFields.has('receiverTown')}]}
          hidden={hiddenFields.has('receiverTown')}
        >
          <Input
            disabled={lockedFields.has('receiverTown')}
            onChange={(e) => {
              if (!invoiceReceiverDataChanged) {
                form.setFieldsValue({
                  receiverInvoiceTown: e.target.value,
                });
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="receiverCounty"
          label="Νομός"
          rules={[{required: !lockedFields.has('receiverCounty')}]}
          hidden={hiddenFields.has('receiverCounty')}
        >
          <Input
            disabled={lockedFields.has('receiverCounty')}
            onChange={(e) => {
              if (!invoiceReceiverDataChanged) {
                form.setFieldsValue({
                  receiverInvoiceCounty: e.target.value,
                });
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="receiverZipcode"
          label="Τ.Κ."
          rules={[{required: !lockedFields.has('receiverZipcode')}]}
          hidden={hiddenFields.has('receiverZipcode')}
        >
          <Input
            disabled={lockedFields.has('receiverZipcode')}
            onChange={(e) => {
              if (!invoiceReceiverDataChanged) {
                form.setFieldsValue({
                  receiverInvoiceZipcode: e.target.value,
                });
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="receiverTel"
          label="Τηλέφωνο παραλήπτη"
          rules={[{required: !lockedFields.has('receiverTel')}]}
          hidden={hiddenFields.has('receiverTel')}
        >
          <Input
            disabled={lockedFields.has('receiverTel')}
            onChange={(e) => {
              if (!invoiceReceiverDataChanged) {
                form.setFieldsValue({
                  receiverInvoiceTel: e.target.value,
                });
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="receiverMobile"
          label="Κινητό παραλήπτη"
          rules={[{required: !lockedFields.has('receiverMobile')}]}
          hidden={hiddenFields.has('receiverMobile')}
        >
          <Input
            disabled={lockedFields.has('receiverMobile')}
            onChange={(e) => {
              if (!invoiceReceiverDataChanged) {
                form.setFieldsValue({
                  receiverInvoiceMobile: e.target.value,
                });
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="unit"
          label="Ποσότητα"
          rules={[{required: !lockedFields.has('unit')}]}
          hidden={hiddenFields.has('unit')}
        >
          <InputNumber precision={0} min={1} style={{width: "100%"}} disabled={lockedFields.has('unit')}/>
        </Form.Item>
        <Form.Item
          name="measurementUnit"
          label="Μονάδα μέτρησης"
          rules={[{required: !lockedFields.has('measurementUnit')}]}
          hidden={hiddenFields.has('measurementUnit')}
        >
          <Select
            disabled={lockedFields.has('measurementUnit')}
            showSearch="true"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
            dropdownMatchSelectWidth={false}
          >
            {measurementUnitOptions}
          </Select>
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.measurementUnit !== currentValues.measurementUnit}>
          {({getFieldValue}) =>
            getFieldValue('measurementUnit') === '000001' && !hiddenFields.has('uDStringField2') ? (
              <Form.Item
                name="uDStringField2"
                label="Τύπος Δέματος"
                rules={[{required: !lockedFields.has('uDStringField2')}]}
              >
                <Select
                  disabled={lockedFields.has('uDStringField2')}
                  showSearch="true"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  dropdownMatchSelectWidth={false}
                >
                  {unitTypeOptions}
                </Select>
              </Form.Item>
            ) : null
          }
        </Form.Item>
        <Form.Item
          name="boxWeight"
          label="Βάρος"
          rules={[{required: !lockedFields.has('boxWeight')}]}
          hidden={hiddenFields.has('boxWeight')}
        >
          <InputNumber
            style={{width: "100%"}}
            decimalSeparator=","
            min={0.001}
            disabled={lockedFields.has('boxWeight')}
          />
        </Form.Item>
        <Form.Item
          name="boxVolume"
          label="Όγκος"
          rules={[{required: !lockedFields.has('boxVolume')}]}
          hidden={hiddenFields.has('boxVolume')}
        >
          <InputNumber
            style={{width: "100%"}}
            decimalSeparator=","
            min={0.001}
            disabled={lockedFields.has('boxVolume')}
          />
        </Form.Item>
        <Form.List name="extraUnits">
          {(fields, {add, remove}, {errors}) => (
            <>
              {fields.map((field, index) => (
                <>
                  <Form.Item
                    key={field.key+(index +2)}
                    {...field}
                    label={"Ποσότητα " + (index + 2)}
                    name={[field.name, "unit"]}
                    fieldKey={[field.fieldKey, "unit"]}
                    rules={[
                      {
                        required: !lockedFields.has('unit'),
                        message:
                          "Υποχρεωτικό πεδίο, αλλιώς αφαιρέστε το  " +
                          (index + 2) +
                          "ο φορτίο",
                      },
                    ]}
                    hidden={hiddenFields.has('unit')}
                  >
                    <InputNumber
                      precision={0}
                      min={1}
                      style={{width: "100%"}}
                      disabled={lockedFields.has('unit')}
                    />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    key={field.key+(index+2)}
                    label={"Μονάδα μέτρησης " + (index + 2)}
                    name={[field.name, "measurementUnit"]}
                    fieldKey={[field.fieldKey, "measurementUnit"]}
                    rules={[
                      {
                        required: !lockedFields.has('measurementUnit'),
                        message:
                          "Υποχρεωτικό πεδίο, αλλιώς αφαιρέστε το  " +
                          (index + 2) +
                          "ο φορτίο",
                      },
                    ]}
                    hidden={hiddenFields.has('measurementUnit')}
                  >
                    <Select
                      disabled={lockedFields.has('measurementUnit')}
                      showSearch="true"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase())
                      }
                      dropdownMatchSelectWidth={false}
                    >
                      {measurementUnitOptions}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    noStyle shouldUpdate={(prevValues, currentValues) => true}>
                    {({getFieldValue}) =>
                      getFieldValue('extraUnits')[index].measurementUnit === '000001' && !hiddenFields.has('uDStringField2') ? (
                        <Form.Item
                          {...field}
                          label={"Τύπος Δέματος " + (index + 2)}
                          name={[field.name, "uDStringField2"]}
                          fieldKey={[field.fieldKey, "uDStringField2"]}
                          rules={[
                            {
                              required: !lockedFields.has('uDStringField2'),
                              message:
                                "Υποχρεωτικό πεδίο, αλλιώς αφαιρέστε το  " +
                                (index + 2) +
                                "ο φορτίο",
                            },
                          ]}
                          hidden={hiddenFields.has('uDStringField2')}
                        >
                          <Select
                            disabled={lockedFields.has('uDStringField2')}
                            showSearch="true"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            dropdownMatchSelectWidth={false}
                          >
                            {unitTypeOptions}
                          </Select>
                        </Form.Item>
                      ) : null
                    }
                  </Form.Item>
                  <Form.Item
                    {...field}
                    key={field.key+(index +2)}
                    label={"Βάρος " + (index + 2)}
                    name={[field.name, "boxWeight"]}
                    fieldKey={[field.fieldKey, "boxWeight"]}
                    rules={[
                      {
                        required: !lockedFields.has('boxWeight'),
                        message:
                          "Υποχρεωτικό πεδίο, αλλιώς αφαιρέστε το  " +
                          (index + 2) +
                          "ο φορτίο",
                      },
                    ]}
                    hidden={hiddenFields.has('boxWeight')}
                  >
                    <InputNumber
                      style={{width: "100%"}}
                      decimalSeparator=","
                      min={0.001}
                      disabled={lockedFields.has('boxWeight')}
                    />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    key={field.key+(index+2)}
                    label={"Όγκος " + (index + 2)}
                    name={[field.name, "boxVolume"]}
                    fieldKey={[field.fieldKey, "boxVolume"]}
                    rules={[
                      {
                        required: !lockedFields.has('boxVolume'),
                        message:
                          "Υποχρεωτικό πεδίο, αλλιώς αφαιρέστε το  " +
                          (index + 2) +
                          "ο φορτίο",
                      },
                    ]}
                    hidden={hiddenFields.has('boxVolume')}
                  >
                    <InputNumber
                      style={{width: "100%"}}
                      decimalSeparator=","
                      min={0.001}
                      disabled={lockedFields.has('boxVolume')}
                    />
                  </Form.Item>
                  <Form.Item wrapperCol={{offset: 7, span: 17}} fieldKey={[field.key, "removeButton"]}>
                    <Button
                      block
                      key={field.key}
                      title={"Αφαίρεση " + (index + 2) + "ου φορτίου"}
                      onClick={() => remove(index)}
                    >
                      <MinusOutlined style={{color: "grey"}}/>
                      {"Αφαίρεση φορτίου " + (index + 2)}
                    </Button>
                  </Form.Item>
                </>
              ))}
              <Form.Item label="Συγκεντρωτικά Σύνολα">
                <Form.Item
                  noStyle
                  shouldUpdate={true}
                >
                  {({getFieldValue}) => {
                    const extraUnits = getFieldValue("extraUnits") || [];
                    const unit = getFieldValue("unit");
                    const type = getFieldValue("measurementUnit");
                    const totals = new Map();
                    if (unit && type) {
                      totals.set(type, unit);
                    }
                    extraUnits.forEach(u => {
                      if (u && u.unit && u.measurementUnit) {
                        if (totals.has(u.measurementUnit)) {
                          totals.set(u.measurementUnit, totals.get(u.measurementUnit) + u.unit);
                        } else {
                          totals.set(u.measurementUnit, u.unit);
                        }
                      }
                    });

                    const totalParts = [];
                    for (const [key, value] of totals.entries()) {
                      const mu = measurementUnits.find(mu => mu.code === key);
                      if (mu) {
                        totalParts.push(`${mu.description}: ${value}`);
                      }
                    }

                    return <span> <i>{totalParts.join(" | ")}</i></span>;
                  }}
                </Form.Item>
              </Form.Item>
              <Form.Item wrapperCol={{offset: 7, span: 17}}>
                <Button
                  block
                  type="dashed"
                  title="Προσθήκη επιπλέον φορτίου"
                  onClick={() => {
                    const allValues = form.getFieldsValue();
                    const {extraUnits} = allValues;
                    const lastItem =
                      extraUnits && extraUnits.length > 0
                        ? extraUnits[extraUnits.length - 1]
                        : {
                          unit: allValues.unit,
                          measurementUnit: allValues.measurementUnit,
                          boxWeight: allValues.boxWeight,
                          boxVolume: allValues.boxVolume,
                        };
                    add({});
                  }}
                >
                  <PlusOutlined style={{color: "grey"}}/>
                  Προσθήκη επιπλέον φορτίου
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>


        <Form.Item
          name="deliveryDate"
          label="Ημερομηνία Παράδοσης"
          rules={[{required: !lockedFields.has('deliveryDate')}]}
          hidden={hiddenFields.has('deliveryDate')}
        >
          <DatePicker
            locale={locale}
            format="D/M/YYYY"
            style={{width: "100%"}}
            disabled={lockedFields.has('deliveryDate')}
          />
        </Form.Item>
        <Form.Item
          hidden={hiddenFields.has('deliverySlot')}
          name="deliverySlot"
          label="Χρονοθυρίδα παράδοσης"
          initialValue={0}
        >
          <Input disabled={lockedFields.has('deliverySlot')}/>
        </Form.Item>
        <Form.Item
          name="paymentType"
          label="Τρόπος πληρωμής εμπορευμάτων"
          rules={[{required: !lockedFields.has('paymentType')}]}
          hidden={hiddenFields.has('paymentType')}
        >
          <Select onChange={(e) => setIsPaymentRequired(e == 0)} disabled={lockedFields.has('paymentType')}>
            <Option value={0}>Αντικαταβολή</Option>
            <Option value={1}>Τράπεζα</Option>
            <Option value={2}>Επιταγή</Option>
            <Option value={3}>Μετρητά</Option>
            <Option value={4}>Paypal</Option>
            <Option value={5}>Πιστωτική</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="paymentAmount"
          label="Ποσό πληρωμής εμπορευμάτων"
          rules={[{required: isPaymentRequired}]}
          hidden={hiddenFields.has('paymentAmount')}
        >
          <InputNumber style={{width: "100%"}} decimalSeparator="," disabled={lockedFields.has('paymentAmount')}/>
        </Form.Item>
        <Form.Item name="paymentCode" label="Κωδικός πληρωμής" hidden={hiddenFields.has('paymentCode')}>
          <Input disabled={lockedFields.has('paymentCode')}/>
        </Form.Item>
        <Form.Item name="isDifferentInvoiceReceiver" valuePropName="checked" label="Χρέωση παραλήπτη" hidden={hiddenFields.has('isDifferentInvoiceReceiver')}>
          <Checkbox
            disabled={lockedFields.has('isDifferentInvoiceReceiver')}
            onChange={(e) => setIsDifferentInvoiceReceiver(e.target.checked)}
          />
        </Form.Item>
        {isDifferentInvoiceReceiver && (
          <>
            <Form.Item
              name="receiverInvoiceName"
              label="Παραλήπτης τιμολόγησης"
              rules={[{required: !lockedFields.has('receiverInvoiceName')}]}
              hidden={hiddenFields.has('receiverInvoiceName')}
            >
              <Input
                style={{
                  color: invoiceReceiverDataChanged && !lockedFields.has('receiverInvoiceName') ? "black" : "grey",
                  fontStyle: invoiceReceiverDataChanged ? "normal" : "italic",
                }}
                disabled={lockedFields.has('receiverInvoiceName')}
                onChange={() => setInvoiceReceiverDataChanged(true)}
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoiceAddress"
              label="Οδός παραλήπτη τιμολόγησης"
              rules={[{required: !lockedFields.has('receiverInvoiceAddress')}]}
              hidden={hiddenFields.has('receiverInvoiceAddress')}
            >
              <Input
                style={{
                  color: invoiceReceiverDataChanged && !lockedFields.has('receiverInvoiceAddress') ? "black" : "grey",
                  fontStyle: invoiceReceiverDataChanged ? "normal" : "italic",
                }}
                disabled={lockedFields.has('receiverInvoiceAddress')}
                onChange={() => setInvoiceReceiverDataChanged(true)}
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoiceTown"
              label="Πόλη παραλήπτη τιμολόγησης"
              rules={[{required: !lockedFields.has('receiverInvoiceTown')}]}
              hidden={hiddenFields.has('receiverInvoiceTown')}
            >
              <Input
                style={{
                  color: invoiceReceiverDataChanged && !lockedFields.has('receiverInvoiceTown') ? "black" : "grey",
                  fontStyle: invoiceReceiverDataChanged ? "normal" : "italic",
                }}
                disabled={lockedFields.has('receiverInvoiceTown')}
                onChange={() => setInvoiceReceiverDataChanged(true)}
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoiceCounty"
              label="Νομός παραλήπτη τιμολόγησης"
              rules={[{required: !lockedFields.has('receiverInvoiceCounty')}]}
              hidden={hiddenFields.has('receiverInvoiceCounty')}
            >
              <Input
                style={{
                  color: invoiceReceiverDataChanged && !lockedFields.has('receiverInvoiceCounty') ? "black" : "grey",
                  fontStyle: invoiceReceiverDataChanged ? "normal" : "italic",
                }}
                disabled={lockedFields.has('receiverInvoiceCounty')}
                onChange={() => setInvoiceReceiverDataChanged(true)}
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoiceZipcode"
              label="Τ.Κ. παραλήπτη τιμολόγησης"
              rules={[{required: !lockedFields.has('receiverInvoiceZipcode')}]}
              hidden={hiddenFields.has('receiverInvoiceZipcode')}
            >
              <Input
                style={{
                  color: invoiceReceiverDataChanged && !lockedFields.has('receiverInvoiceZipcode') ? "black" : "grey",
                  fontStyle: invoiceReceiverDataChanged ? "normal" : "italic",
                }}
                disabled={lockedFields.has('receiverInvoiceZipcode')}
                onChange={() => setInvoiceReceiverDataChanged(true)}
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoiceTel"
              label="Τηλέφωνο παραλήπτη τιμολόγησης"
              rules={[{required: !lockedFields.has('receiverInvoiceTel')}]}
              hidden={hiddenFields.has('receiverInvoiceTel')}
            >
              <Input
                style={{
                  color: invoiceReceiverDataChanged && !lockedFields.has('receiverInvoiceTel') ? "black" : "grey",
                  fontStyle: invoiceReceiverDataChanged ? "normal" : "italic",
                }}
                disabled={lockedFields.has('receiverInvoiceTel')}
                onChange={() => setInvoiceReceiverDataChanged(true)}
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoiceMobile"
              label="Κινητό παραλήπτη τιμολόγησης"
              rules={[{required: !lockedFields.has('receiverInvoiceMobile')}]}
              hidden={hiddenFields.has('receiverInvoiceMobile')}
            >
              <Input
                style={{
                  color: invoiceReceiverDataChanged && !lockedFields.has('receiverInvoiceMobile') ? "black" : "grey",
                  fontStyle: invoiceReceiverDataChanged ? "normal" : "italic",
                }}
                disabled={lockedFields.has('receiverInvoiceMobile')}
                onChange={() => setInvoiceReceiverDataChanged(true)}
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoicePaymentType"
              label="Τρόπος πληρωμής μεταφοράς"
              rules={[{required: !lockedFields.has('receiverInvoicePaymentType')}]}
              hidden={hiddenFields.has('receiverInvoicePaymentType')}
            >
              <Select disabled={lockedFields.has('receiverInvoicePaymentType')}>
                {paymentMethods && paymentMethods.map((_) => (<Option value={_.description}>{_.description}</Option>))}
              </Select>
            </Form.Item>
            <Form.Item
              name="receiverInvoicePaymentAmount"
              label="Ποσό πληρωμής υπηρεσίας"
              rules={[{required: !lockedFields.has('##')}]}
              hidden={hiddenFields.has('receiverInvoicePaymentAmount')}
            >
              <InputNumber disabled={lockedFields.has('receiverInvoicePaymentAmount')} style={{width: "100%"}} decimalSeparator=","/>
            </Form.Item>
            <Form.Item
              name="receiverInvoiceTaxRegistrationNumber"
              label="ΑΦΜ παραλήπτη τιμολόγησης"
              hidden={hiddenFields.has('receiverInvoiceTaxRegistrationNumber')}
            >
              <Input disabled={lockedFields.has('receiverInvoiceTaxRegistrationNumber')}
                     onChange={(e) =>
                       setInvoiceTaxRegNumberHasValue(!!e.target.value)
                     }
              />
            </Form.Item>
            <Form.Item
              name="receiverInvoiceTaxOffice"
              label="ΔΟΥ παραλήπτη τιμολόγησης"
              rules={[
                {
                  required: invoiceTaxRegNumberHasValue,
                  message: "Υποχρεωτικό πεδίο εφόσον εισάγατε ΑΦΜ",
                },
              ]}
              hidden={hiddenFields.has('receiverInvoiceTaxOffice')}
            >
              <Select
                disabled={lockedFields.has('receiverInvoiceTaxOffice')}
                showSearch="true"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
              >
                {taxOffices &&
                  taxOffices.map((x) => (
                    <Option value={x.code}>{x.description}</Option>
                  ))}
              </Select>
            </Form.Item>
          </>
        )}
        <Form.Item name="comments" label="Σχόλια" hidden={hiddenFields.has('comments')}>
          <Input.TextArea disabled={lockedFields.has('comments')}/>
        </Form.Item>
        <div style={{padding: "10px"}}>
          <Button type="primary" htmlType="submit" style={{float: "right"}}>
            Αποθήκευση
          </Button>
          <div style={{clear: "both"}}></div>
        </div>
      </Form>
    </Loading>
  );
}

export default ShippingOrderForm;
